// @ts-nocheck
import React from 'react';
import { useTranslation } from 'react-i18next';
import KwPanel from '../../../common/KwPanel';
import { connect } from 'react-redux';

const PackageTypeKeyProviders = ({
  keyProviders,
  packageTypeKeyProviders,
  onChange,
}) => {
  const { t } = useTranslation();
  return (
    <KwPanel className="mb-4 pb-2">
      <header className="mb-2">
        <h2 className="no-margin">{t('Key provider references')}</h2>
      </header>
      {keyProviders && keyProviders.length > 0 ? (
        <table className="table table-has-buttons width-100">
          <thead>
            <tr>
              <th>{t('Name')}</th>
              <th>{t('Reference')}</th>
            </tr>
          </thead>
          <tbody>
            {keyProviders?.map((keyProvider) => {
              const packageTypeKeyProvider =
                packageTypeKeyProviders[keyProvider.id];

              return (
                <tr key={keyProvider.id}>
                  <td>{keyProvider.name}</td>
                  <td>
                    <input
                      data-cy={`${keyProvider.name}-key-provider-reference-input`}
                      onChange={(e) => {
                        onChange(keyProvider, e.target.value);
                      }}
                      placeholder=""
                      className="form-control"
                      defaultValue={packageTypeKeyProvider || ''}
                      name={keyProvider.name}
                      data-lpignore="true"
                      autoComplete="off"
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      ) : (
        t('None')
      )}
    </KwPanel>
  );
};



function mapStateToProps(state) {
  return {
    keyProviders: state.keyProviders,
  };
}

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PackageTypeKeyProviders);
